<template>
  <div id="depositBonus">
    <div class="content_box">
      <div class="inner">
        <div class="contact_title">
          <h2>{{ dataConfiguration.pageTitle || dataConfiguration.title }}</h2>
          <p></p>
        </div>
        <FundAccount :dataConfiguration="dataConfiguration"></FundAccount>
        <div class="overBonusAlert" v-if="overBonus">
          {{ $t('promotion.depositBonus.overBonus', { maxAmount: creditLimit }) }}
        </div>
        <div class="table_box">
          <div class="table_title">
            {{ $t('promotion.depositBonus.bonusHistory') }}
          </div>
          <ul class="table_demo">
            <li class="table_item" :class="{ active: activeName === 'creditReceived' }">
              <CreditReceived
                :tableData="tableData"
                :welcomeRateLimit="welcomeRateLimit"
                :stdRateLimit="stdRateLimit"
                :extraWelcomeRateLimit="extraWelcomeRateLimit"
              ></CreditReceived>
            </li>
          </ul>
        </div>
        <OptInOut :optIn="optIn" @successfulCallback="successfulCallback"></OptInOut>
      </div>
    </div>
  </div>
</template>

<script>
import FundAccount from '@/components/newDepositBonus/FundAccount';
import OptInOut from '@/components/newDepositBonus/OptInOut';
import CreditReceived from '@/components/newDepositBonus/CreditReceived';
import { apiCampaignInfo } from '@/resource';

export default {
  name: 'depositBonus',
  components: { FundAccount, OptInOut, CreditReceived },
  data() {
    return {
      activeName: 'creditReceived',
      overBonus: false,
      creditLimit: undefined,
      welcomeRateLimit: undefined,
      stdRateLimit: undefined,
      extraWelcomeRateLimit: undefined,
      tableData: [],
      dataConfiguration: {},
      optIn: true
    };
  },
  computed: {
    campaignID() {
      return this.$route.params.campaignId;
    },
    langUsed() {
      return this.$store.state.common.lang;
    }
  },
  watch: {
    langUsed() {
      this.getDespositBonusInfo();
    },
    campaignID() {
      this.getDespositBonusInfo();
    }
  },

  methods: {
    getDespositBonusInfo() {
      apiCampaignInfo(this.campaignID, this.langUsed)
        .then(resp => {
          if (resp.data.code === 0) {
            this.tableData = resp.data.data.participants;
            this.optIn = resp.data.data.in;
            this.overBonus = resp.data.data.reachedMaximumBonus;
            this.creditLimit = resp.data.data.creditLimit.toLocaleString('en-US');
            this.welcomeRateLimit = resp.data.data.welcomeRateLimit;
            this.stdRateLimit = resp.data.data.stdRateLimit;
            this.extraWelcomeRateLimit = resp.data.data.extraWelcomeRateLimit;
            this.dataConfiguration = resp.data.data.clientPortalSettings;
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    successfulCallback(optIn) {
      this.$message({
        message: optIn ? this.$t('promotion.depositBonus.optIn') : this.$t('promotion.depositBonus.optOut'),
        type: 'success',
        duration: 5000
      });
      this.getDespositBonusInfo();
    }
  },
  mounted() {
    this.getDespositBonusInfo();
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/pages/depositBonus.scss';
</style>
